import React, { FC } from "react";
import { observer } from "mobx-react-lite";
import { useRoutes } from "react-router-dom";
import { STANDARD_MODE_ROUTES } from "@/app/router/standard-mode-routes";
import { NotFoundPage } from "@/pages/not-found";
import { Tab } from "@/store/navigation/types";

interface CenterPanelRouterProps {
  tab: Tab;
}

export const CenterPanelRouter: FC<CenterPanelRouterProps> = observer(({ tab }) => {
  const tabPath = tab.path;
  if (!tabPath) return <NotFoundPage />;
  const element = useRoutes(STANDARD_MODE_ROUTES, tabPath);
  return <React.Fragment key={tab.id}>{element}</React.Fragment>;
});
